<script lang="ts">
    import ProjectsPage from '@Quest/CorporateScenarios/Pages/ProjectsPage'
    export default ProjectsPage
</script>

<template>
    <div>
        <CorporateNavigation ActivePage="dashboard"></CorporateNavigation>

        <div v-if="rm" class="container-fluid" style="margin-top: 80px; padding-top: 20px;">
            <div class="row">
                <div class="col-lg-6">
                    <small class="text-muted">Enterprise Plan: {{rm.ScenarioName}}</small>
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">Projects</h1>
                </div>
                <div class="col-lg-6 d-flex flex-column justify-content-end">
                    <ScenarioNavigation />
                </div>
            </div>

            <hr />

            <div class="row mt-5">
                <div class="col-lg-6 col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="float-right">
                                <div class="dropdown d-inline mr-2">
                                    <button data-toggle="dropdown" class="btn btn-secondary btn-sm">Legend</button>
                                    <div class="dropdown-menu dropdown-menu-right" role="menu">
                                        <span v-for="p in rm.Portfolios" :key="p.Id" class="dropdown-item-text">
                                            <i class="fa-solid fa-circle" :style="{'color': p.Color}"></i> {{p.Name}}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <h5>Efficient Frontier</h5>
                        </div>
                        <div class="card-body chart-container">
                            <div id="Chart-EfficientFrontier" style="max-width: 100%; height: 100%; overflow: auto;"></div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="float-right">
                                <div class="dropdown d-inline mr-2">
                                    <button data-toggle="dropdown" class="btn btn-secondary btn-sm">Legend</button>
                                    <div class="dropdown-menu dropdown-menu-right" role="menu">
                                        <span v-for="p in rm.Portfolios" :key="p.Id" class="dropdown-item-text">
                                            <i class="fa-solid fa-circle" :style="{'color': p.Color}"></i> {{p.Name}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <h5>Prioritization Matrix</h5>
                        </div>
                        <div class="card-body chart-container">
                            <div id="Chart-PrioritizationMatrix" style="max-width: 100%; height: 100%; overflow: auto;"></div>
                        </div>
                    </div>
                </div>

            </div>

            <br /><br />

            <div>
                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th class="align-middle" style="min-width: 300px; width: 300px; max-width: 300px;">Project</th>
                                <th class="text-center align-middle" style="min-width: 100px; width: 100px; max-width: 100px;">P&L</th>
                                <th class="text-center align-middle" style="min-width: 250px; width: 250px; max-width: 250px;">Portfolio</th>
                                <th class="text-center align-middle" style="min-width: 200px; width: 200px; max-width: 200px;">Cost of value point <br /> ({{rm.CurrencyLabel}})</th>
                                <th class="text-right align-middle" style="min-width: 250px; width: auto;">Costs <br /> ({{rm.CurrencyLabel}})</th>
                                <th class="align-middle" style="min-width: 250px; width: auto; ">Value <br /> (0-100)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="a in projectsView" :key="a.Id">
                                <td style="min-width: 300px; width: 300px; max-width: 300px; ">
                                    <a class="text-primary" v-sanitizedHref="`/#/alternative/dashboard/${a.PortfolioWorkspaceId}/${a.PortfolioTchProjectId}/${a.Id}`">
                                        {{a.Name}}
                                    </a>
                                </td>
                                <td class="text-center align-middle" style="min-width: 100px; width: 100px; max-width: 100px; ">
                                    <a v-if="a.HasActivePlan" class="text-primary" v-sanitizedHref="`/#/q/project/pnl/${a.PortfolioWorkspaceId}/${a.PortfolioTchProjectId}/${a.Id}`">
                                        View
                                    </a>
                                    <a v-else class="text-danger" v-sanitizedHref="`/q/project/summary/${a.PortfolioWorkspaceId}/${a.PortfolioTchProjectId}/${a.Id}`">
                                        Not available
                                    </a>
                                </td>
                                <td class="text-center align-middle" style="min-width: 250px; width: 250px; max-width: 250px; ">
                                    <a class="text-primary" v-sanitizedHref="`/#/portfolio-plan/selection/${a.PortfolioWorkspaceId}/${a.PortfolioTchProjectId}/${a.ScenarioId}`">
                                        {{a.PortfolioName}}
                                    </a>
                                </td>
                                <td class="text-center align-middle" style="min-width: 200px; width: 200px; max-width: 200px;">
                                    {{fmtNum(a.CostOfValuePoint)}}
                                </td>
                                <td class="text-right align-middle" style="min-width: 250px; width: auto; ">
                                    <div class="progress justify-content-end" style="height: 30px;">
                                        <div class="progress-bar bg-danger" role="progressbar" :style="{width: a.NormalizedTotalCost + '%'}">
                                            {{fmtNum(a.TotalCost)}}
                                        </div>
                                    </div>
                                </td>
                                <td class="align-middle" style="min-width: 250px; width: auto;">
                                    <div class="progress" style="height: 30px;">
                                        <div class="progress-bar bg-success" role="progressbar" :style="{width: a.TotalValue + '%'}">
                                            {{fmtNum(a.TotalValue)}}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>


        </div>
    </div>
</template>

<style scoped>
</style>
